import React from 'react';
import divider from '../../assets/divider-img.png';
import s1 from '../../assets/connect1.png';
import s2 from '../../assets/connect2.png';

const CustomExecution = () => {
  return (
    <div className="custom-execution">
      <div className="container">
        <div className="center-heading-description heading-white">
          <h2>Execution Management</h2>
          <div className="divider">
            <img src={divider} alt="divider" />
          </div>
          <p>
            Revolutionize Your Trading Experience with Our Advanced Execution
            Engine: Our platform offers seamless connectivity across multiple
            exchanges, ensuring that you never miss a trading opportunity. With
            our advanced algorithmic strategies, comprehensive risk management
            tools, and robust API integrations, you can trade with confidence
            and precision.
          </p>
        </div>
        <div className="custom-execution-wrapper">
          <div className="blue-purple-border">
            <div className="execution-item">
              <h4>Seamless Connectivity and Multi-Platform Trading</h4>
            </div>
          </div>
          <div className="sep-img">
            <img src={s1} alt="divider" />
          </div>
          <div className="blue-purple-border">
            <div className="execution-item">
              <h4>
                Empowerment Through Cutting-Edge Strategies and Risk Management
              </h4>
            </div>
          </div>
          <div className="sep-img">
            <img src={s2} alt="divider" />
          </div>
          <div className="blue-purple-border">
            <div className="execution-item">
              <h4>Unmatched Performance, Security, and Success</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomExecution;
